import { Injectable } from '@angular/core';
import { FunctionsService } from '../__common/functions.service';
import { GuiFlowService } from '../__gui/gui-flow.service';
import { ConfigService } from '../___common/__config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ShopifyService {

  userId: number;

  constructor(private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private configService: ConfigService) {
    this.userId = this.commonFunctions.getSelectedClientId(); // Get logged-in user ID
  }

  getShopifyCheckoutUrl(variantId, quantity: number): string {
    return this.configService.getApiUrlRefactor('myShopUrl')+`cart/${variantId}:${quantity}?attributes[user_id]=${this.userId}&attributes[order_token]=${this.commonFunctions.getCurrentToken()}`;
  }

  smartFind(
    obj: { [key: string]: string },
    search: string | number
  ): { variantId: string; databaseId: string } | undefined {
    const key = String(search); // normalize to string
  
    if (obj.hasOwnProperty(key)) {
      return { variantId: key, databaseId: obj[key] };
    }
  
    const entry = Object.entries(obj).find(([_, value]) => value === key);
    if (entry) {
      const [variantId, databaseId] = entry;
      return { variantId, databaseId };
    }
  
    return undefined;
  }
  

  buyProduct(obj){
    let baseUrl = '';
    obj.user_id? this.userId = obj.user_id : null;

    let productId = this.smartFind(this.configService.getStockProductsFromShopify(),obj.productVariantId);
    if(productId && productId.variantId){
      baseUrl = this.getShopifyCheckoutUrl(productId.variantId,1);
      window.open(baseUrl,'__blank');
    }else{
      console.log('ERROR: No variant ID found in switch @shopifyService');
      this.guiFlow.openSimpleSnackBar('Error, contacta con el admin','error',null,'');
    }
  }

}
